module.exports = __webpack_public_path__ + "static/media/logo.5fa29e10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 641
// module chunks = 2